import { STYLE_LIST } from '../../../config/dataConfig/FJImageToImageData';
import { useSelector, useDispatch } from 'react-redux';
import {
    setSliceSelectedStyleAction,
    setSliceSelectStyleCategoryAction,
} from '../../../redux/slices/FJSliceImageToImage';
import { useCallback } from 'react';
import FJModalList from './FJModalList';
import useLocalStore from '../../../hooks/useLocalStore';

const FJModalListContainer = ({ id }) => {
    useLocalStore();
    const selectedStyle = useSelector(state => state.imageToImage.selectedStyle);
    const selectStyleCategory = useSelector(state => state.imageToImage.selectStyleCategory);
    const openPromptInput = useSelector(state => state.imageToImage.openPromptInput);

    const dispatch = useDispatch();

    const changeStyle = useCallback(
        value => {
            dispatch(setSliceSelectedStyleAction(value));
        },
        [dispatch],
    );
    const setSelectStyleCategory = useCallback(
        value => {
            dispatch(setSliceSelectStyleCategoryAction(value));
        },
        [dispatch],
    );

    return (
        <FJModalList
            list={STYLE_LIST}
            openPromptInput={openPromptInput}
            onChange={changeStyle}
            value={selectedStyle}
            selectStyleCategory={selectStyleCategory}
            setSelectStyleCategory={setSelectStyleCategory}
            id={id}
        />
    );
};

export default FJModalListContainer;
